import type { Example } from '../types';

export const angleDialExample: Example = {
  id: 'angle-dial',
  title: 'Angle Dial & XY/XYZ Pads',
  categoryId: 'parameters',
  description: 'Circular arc dial, draggable 2D/3D canvas inputs',
  scadCode: `/* Angle Dial & XY/XYZ Pads */

// markdown:tip
// **Angle Dial** — Add a \`°\` symbol to the range comment to get a circular
// arc dial instead of a slider. **XY Pad** — a two-element array with two
// \`min:max\` ranges becomes a draggable 2D canvas. **XYZ Pad** adds a Z slider.

/* [Rotation] */

// Rotation angle — the ° triggers the arc dial widget
rotation = 0; // [0°:360°]

// Tilt angle
tilt = 20; // [−90°:90°]

/* [Position] */

// XY offset — drag on the 2D canvas
offset_xy = [0, 0]; // [-40:40, -40:40]

/* [Scale & Twist] */

// XYZ scale — XY canvas + Z slider
scale_xyz = [1.0, 1.0, 1.0]; // [0.3:2.0, 0.3:2.0, 0.3:2.0]

/* [Appearance] */

// Color
// color
part_color = [0.3, 0.65, 0.5];

// --- parameters end ---

translate([offset_xy[0], offset_xy[1], 0])
rotate([tilt, 0, rotation])
scale(scale_xyz)
color(part_color) {
  // Base disc
  cylinder(d=50, h=6, center=true, $fn=64);
  // Tower
  translate([0, 0, 3 + 20])
    cylinder(d=12, h=40, center=true, $fn=32);
  // Cap sphere
  translate([0, 0, 3 + 42])
    sphere(r=9, $fn=40);
  // Three radial arms
  for (a = [0, 120, 240])
    rotate([0, 0, a])
    translate([18, 0, 3 + 5])
      cube([18, 5, 5], center=true);
}
`,
};
